import { useAuth } from '../auth/AuthContext';
import PeladasPage from './cloud/PeladasPage';
import LandingPage from './landing/LandingPage';

// A raiz serve duas pessoas diferentes.
//
// Quem não tem conta chega pelo link no grupo do WhatsApp e precisa entender o
// produto antes de qualquer coisa — para essa pessoa, a raiz é a landing.
//
// Quem já entrou não quer ler propaganda do que já usa: cai direto nas peladas.
export default function HomePage() {
  const { user, loading } = useAuth();

  if (loading) return null;
  return user ? <PeladasPage /> : <LandingPage />;
}
